import { State } from "infrontjs";

export class InAppState extends State
{
    static ROUTE = null;
    static ID = null;

    canEnter()
    {
        if ( this.app.user !== null )
        {
            return true;
        }
        else
        {
            return false;
        }
    }

    async exit()
    {
        if ( this.app.view.pageContent )
        {
            this.app.view.pageContent.innerHTML = '';
        }
    }

    getRedirectUrl()
    {
        // Literal (mirrors LoginState.ROUTE). Importing LoginState here would
        // create a circular dependency (InAppState → LoginState → AuthState →
        // IndexState → InAppState) that breaks class-extends at load time.
        return '/login';
    }

    getContentHeaderData()
    {
        return {
            title: '',
            breadcrumb: []
        };
    }

    /**
     * Is this state still the one on screen?
     *
     * The guard to use after every await in a state: a screen that navigates
     * away while a request is in flight is disposed, and disposal NULLS
     * `this.app` — so the obvious `this.app.stateManager.currentState !== this`
     * throws exactly in the case it was written to handle. (Same as the
     * client-admin's InAppState.)
     */
    isActive()
    {
        return !!this.app && this.app.stateManager?.currentState === this;
    }
}
